import { executeRequest, Request } from '@jfs/network'
import { AESEncryption, getRandomAlphaNumString, RSAEncryption } from '@jfs/utils'
import { APIEndPoints } from '../../network/APIEndpoints'
import { sitConfigQrAgentPortal } from '../../network/config'

const responseParser = (data: any) => {
  return data
}

const verifyOtpBody = (mobileNumber: string, encOtp: string, encryptionKey: string) => {
  return {
    user: {
      mobile: {
        mobileNumber: mobileNumber,
        countryCode: '91',
      },
      entityType: 2,
    },
    scope: 'SESSION', //isExistingUser ? 'SESSION' : 'REQUEST', //TODO: check and uncomment
    authenticateList: [
      {
        mode: '1',
        value: encOtp,
        action: 'verify',
      },
    ],
    secure: {
      encryptionKey: encryptionKey,
    },
    purpose: 1,
  }
}

const loginVerifyOtp = (otp: string, mobileNumber: string, tokens: any, userAccessToken: string) => {
  const { REACT_APP_PUBLIC_ENC_KEY } = (window?._env_ ?? {})
  const PUBLIC_ENC_KEY: any = REACT_APP_PUBLIC_ENC_KEY

  let randomEncryptionKey = getRandomAlphaNumString(32)
  const encryptionKey: any = RSAEncryption(randomEncryptionKey, PUBLIC_ENC_KEY)
  let encOtp = AESEncryption(randomEncryptionKey, otp)

  const request: Request<{}> = {
    apiPath: APIEndPoints.Login,
    method: 'POST',
    config: sitConfigQrAgentPortal(tokens),
    body: verifyOtpBody(mobileNumber, encOtp, encryptionKey),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }

  return executeRequest(request)
    .then((data) => {
      if (data.data.status === 'SUCCESS') {
        return responseParser(data)
      } else {
        throw data
      }
    })
    .catch((error) => {
      throw error
    })
}

export { loginVerifyOtp }
